import React, { useState, useEffect } from "react";
import "../../../../src/styles/userManagement.css";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import DefineWorkProgram from "../../Plan/AnalystWorkProgram/defineWorkProgram";
import PropTypes from "prop-types";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

export default function WorkProgramCreation(props) {
  const { AssessmentData,getAssessments, handleDelete } = props
  const [modalVisible, setModalVisible] = useState(false);
  const [editScreen, setEditScreen] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [planID, setPlanID] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [assessmentRequestId, setAssessmentRequestId] = useState(null);
  const [wPRequestData, setWPRequestData] = useState(null);
  const [edit, setEdit] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const[loader,setLoader]=useState(true);

  const { sendRequest: getAllVendorList } = useHttp();

  const getVendors = async () => {
    getAllVendorList(APIService.getAllVendorList(), (res) => {
      if (res.CODE) {
        setVendors(res.MSG)
        setLoader(false);
      }
    })
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  function formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  const getWorkprogrammeDetails = async (assessmentRequestId) => {
    const filteredData = props.AssessmentData.filter(
        (item) => item.vendorassessmentrequestid == assessmentRequestId
      );
      if (filteredData.length>0 && filteredData[0].workprogrammeid != null) {
        setWPRequestData(filteredData[0].workprogrammeid)
      }
    };

   

  useEffect(() => {
    setEditScreen(false)
    getVendors()
    setTableData(AssessmentData);
    setFilter(AssessmentData);
    let totalPageLength = Math.ceil((AssessmentData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [AssessmentData]);

  useEffect(() => {
    getWorkprogrammeDetails(assessmentRequestId)
  }, [assessmentRequestId]);

  useEffect(() => {
    const result = tableData?.filter((wpList) => {
      return wpList?.vendorName.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }, [search]);

  const handleBack = () => {
    setEditScreen(false)
    getAssessments();
    setTableData(AssessmentData);
    setFilter(AssessmentData);
    let totalPageLength = Math.ceil((AssessmentData?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
    setWPRequestData(null);
    setSearch("");
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
  }

  const renderNextPlannedDate = (row) => {
    return formatDate(row?.nextPlannedDate);
  }

  const renderActionCell = (row) => {
    if (row?.wpstatus!='Approved' && !(row?.workprogrammeid)) {
      return (
        <>
          <span className=" Appkit4-icon icon-circle-plus-fill  action-icon pointer" title="Create/Update Workprogram" onClick={() => handleEditButton(row)}></span>&nbsp;
          <span className=" Appkit4-icon icon-delete-fill  action-icon pointer" title="Delete Workprogram" onClick={() => handleDeleteButton(row)}></span>
        </>
      )
    }
    if (row?.wpstatus!='Approved' && (row?.workprogrammeid)) {
      return (
        <>
          <span className=" Appkit4-icon icon-view-fill action-icon pointer" title="View  Workprogram" onClick={() => handleViewButton(row)}></span>&nbsp;
          <span className=" Appkit4-icon icon-circle-plus-fill  action-icon pointer" title="Create/Update Workprogram" onClick={() => handleEditButton(row)}></span>&nbsp;
          <span className=" Appkit4-icon icon-delete-fill  action-icon pointer" title="Delete Workprogram" onClick={() => handleDeleteButton(row)}></span>
        </>
      )
    }
    if (row?.workprogrammeid) {
      return (
        <span className=" Appkit4-icon icon-view-fill action-icon pointer" title="View  Workprogram" onClick={() => handleViewButton(row)}></span>
      )
    }
  }

  const handleViewButton = (row) => {
    setSelectedVendor(Number(row?.vendorid))
    setAssessmentRequestId(Number(row?.vendorassessmentrequestid))
    setEditScreen(true);
    setEdit(false);
    setSearch("");
  }

  const handleEditButton = (row) => {
    setSelectedVendor(Number(row?.vendorid))
    setAssessmentRequestId(Number(row?.vendorassessmentrequestid))
    setEditScreen(true);
    setEdit(true);
    setSearch("");
  }

  const handleDeleteButton = (row) => {
    setPlanID(row?.vendorassessmentplanid);
    setModalVisible(true);
    setSearch("");
  }

  return (
    <div className="App">
      {editScreen ?
        <DefineWorkProgram
          sendBack={handleBack}
          vendors={vendors}
          selectedVendor={selectedVendor}
          assessmentRequestId={assessmentRequestId}
          AssessmentData={AssessmentData}
          WPRequestData={wPRequestData}
          edit={edit}
          loader={loader}
        /> :
        <div className="col-lg-12 mt-3 pl-1">
          {tableData.length > 0 ? (
            <Input
            type="text"
            title= "Search Third Party Name"
            value={search}
            className="ap-field-wrapper-tableSearch"
            onChange={(e) => setSearch(e)}
          /> 
          ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "" : "biaTableBU"}>
                    <Column field="vendorName" className={filter.length === 0 ? "" : "oneSeventy"} sortKey={filter.length > 0 ? "vendorName" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Third Party Name</Column>
                    <Column field="vendor_status" className={filter.length === 0 ? "" : "oneHundred"} sortKey={filter.length > 0 ? "vendor_status" : ""}>Status</Column>
                    <Column field="wpstatus" className={filter.length === 0 ? "" : "twoHundred"} sortKey={filter.length > 0 ? "wpstatus" : ""}>Work Program Status</Column>
                    <Column field="nextPlannedDate" className={filter.length === 0 ? "" : "twoHundred"} sortKey={filter.length > 0 ? "nextPlannedDate" : ""} renderCell={renderNextPlannedDate}>Next Planned Date</Column>
                    <Column field="assessmentType" className={filter.length === 0 ? "" : "oneSeventy"} sortKey={filter.length > 0 ? "assessmentType" : ""}>Assessment Type</Column>
                    <Column field="assessor" className={filter.length === 0 ? "" : "oneFifty"} sortKey={filter.length > 0 ? "assessor" : ""}>Assessor</Column>
                    <Column field="vendorassessmentrequestid"
                    className={filter.length === 0 ? "" : "oneFifty"}
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
      }
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onClick={handleCancel}
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
           <div className="modal-title">
           Are you sure you want to delete this workprogram request?
          </div>
          <ModalFooter>
           
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
            </button>

              <button
                type="submit"
                className="save-button m-l-2"
                onClick={() => handleDelete(planID, Number(sessionStorage.getItem("userId")), setModalVisible)}
              >
                Yes
            </button>
          
          </ModalFooter>
        </Modal>
      </div>
    </div>
  )
};

WorkProgramCreation.propTypes = {
  AssessmentData: PropTypes.any, 
  handleDelete: PropTypes.any,
  getAssessments: PropTypes.any
}

